/**
 * Shared split layout for the pre-shell auth surfaces (sign up, forgot
 * password, reset password). Mirrors the login page's grid: a centered
 * credentials pane on the left and the decorative BrandPanel on the right.
 * Token-driven; no raw hex.
 */
import type { ReactNode } from 'react'
import { BrandPanel } from './brand-panel'

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="grid lg:grid-cols-[2fr_1fr]" style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--s-10) var(--s-12)',
        }}
      >
        <div style={{ width: '100%', maxWidth: 384 }}>{children}</div>
      </div>
      <BrandPanel />
    </div>
  )
}

/** The IntegraTrace · Console header used atop each auth pane. */
export function AuthPaneHeader({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <header>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--s-2)' }}>
        <img src="/assets/logos/logo_mark.png" alt="" width={22} height={22} aria-hidden="true" />
        <span className="kicker">IntegraTrace · Console</span>
      </div>
      <h1
        style={{
          margin: 'var(--s-3) 0 var(--s-1)',
          fontFamily: 'var(--ff-display)',
          fontSize: 'var(--fs-28)',
          fontWeight: 'var(--fw-semibold)',
          letterSpacing: 'var(--tracking-tight)',
          color: 'var(--text)',
        }}
      >
        {title}
      </h1>
      <p style={{ fontSize: 'var(--fs-13)', color: 'var(--text-mute)' }}>{subtitle}</p>
    </header>
  )
}

/** Inline error alert shared across auth forms (matches the login look). */
export function AuthErrorAlert({ message }: { message: string }) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'var(--s-2)',
        padding: 'var(--s-3)',
        borderRadius: 'var(--r-sm)',
        background: 'var(--err-100)',
        border: '1px solid var(--err-200)',
        color: 'var(--err-700)',
        fontSize: 'var(--fs-13)',
        lineHeight: 'var(--lh-normal)',
      }}
    >
      {message}
    </div>
  )
}
